import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-ellipsis-page-ui',
    templateUrl: './bb-ellipsis-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbEllipsisPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
